import { render, staticRenderFns } from "./ModelDashboard.vue?vue&type=template&id=8bb5e376&"
import script from "./ModelDashboard.vue?vue&type=script&lang=js&"
export * from "./ModelDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ModelDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports